<template>
  <v-pagination density="compact" v-model="props.paginatorData.currentPage"
                :length="Math.ceil(props.paginatorData.totalCount / props.paginatorData.itemsPerPage )"
                :total-visible="3" border active-color="black" color="black" show-first-last-page first-aria-label="First" rounded="0">
  </v-pagination>
</template>

<script setup lang="ts">
import { watch, ref } from "vue";
import { useRoute,useRouter } from "vue-router";
import Paginator from "../service/PaginatorService";
import {useDisplay} from "vuetify";

const emit = defineEmits(['pageChange']);
const props = defineProps({paginatorData: {required: true, type: Paginator}, nav:{type:Boolean, default: true}, limit: Number});
const limitRef = ref<any>(props.limit);
const route = ref<any>(useRoute());
const router = ref<any>(useRouter());
const display = ref(useDisplay());
const isActiveMobileDevice = ref(display.value.mobile);

watch(() => props.paginatorData.currentPage,async () => {
    emit('pageChange', props.paginatorData.currentPage);
    if(props.nav) {
      await router.value.push({name: route.value.name,query: Object.assign({}, route.value.query, { page: props.paginatorData.currentPage})});
    } else {
      props.paginatorData.doCalculations();
      props.paginatorData.routeFunc();
    }
});

watch(() => display.value, () => {
  isActiveMobileDevice.value = display.value.mobile;
})

</script>

<style lang="scss" scoped>
:deep(.v-btn--icon.v-btn--density-compact) {
  padding:0px 20px 0px 20px;
}
</style>